export default [
  { name: 'All', value: '*' },
  { name: 'System Admin', value: 'system:admin' },
  { name: 'System Settings', value: 'system:settings' },
  { name: 'Request Create', value: 'request:create' },
  { name: 'Request View', value: 'request:view' },
  { name: 'Request View All', value: 'request:view:all' },
  { name: 'Request Update', value: 'request:update' },
  { name: 'Request Delete', value: 'request:delete' },
  { name: 'Request Assign', value: 'request:assign' },
  { name: 'Request Approve', value: 'request:approve' },
  { name: 'Request Reject', value: 'request:reject' },
  { name: 'User View', value: 'user:view' },
  { name: 'User Create', value: 'user:create' },
  { name: 'User Update', value: 'user:update' },
  { name: 'User Delete', value: 'user:delete' },
  { name: 'User Manage Roles', value: 'user:manage:roles' },
  { name: 'Role View', value: 'role:view' },
  { name: 'Role Create', value: 'role:create' },
  { name: 'Role Update', value: 'role:update' },
  { name: 'Role Delete', value: 'role:delete' },
  { name: 'Role Manage Permissions', value: 'role:manage:permissions' },
  { name: 'Group View', value: 'group:view' },
  { name: 'Group Create', value: 'group:create' },
  { name: 'Group Update', value: 'group:update' },
  { name: 'Group Delete', value: 'group:delete' },
  { name: 'Group Manage Members', value: 'group:manage:members' },
  { name: 'Invite Create', value: 'invite:create' },
  { name: 'Invite View', value: 'invite:view' },
  { name: 'Invite Delete', value: 'invite:delete' },
] as const;
